import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "..";

const selectSelf = (state: RootState) => state.ui;

export const selectInitialEan = createSelector(selectSelf, (state) => state.initialEan);
export const selectCombiDealModals = createSelector(selectSelf, (state) =>
  state.combiDealModals.filter(
    (modal) =>
      !state.dismissedCombiDealModals.find((dismissed) => dismissed.productId === modal.productId)
  )
);
